import { Router } from "@gatsbyjs/reach-router";
import { useState } from "react";
import ChatBox from "./ChatBox";
import { SystemContext } from "./context";
import { logout } from '@carrier-sce-sharedpackages/auth-module';

import {
  AppBar,
  Avatar,
  Box,
  CssBaseline,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  Drawer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  List,
  ListItem,
  ListItemText,

} from "@material-ui/core";
import { Logout, HelpOutline, Category } from "@mui/icons-material";
import useStyles from "./Style";
import getUsernameFromToken from "./User";
import logo from "./assets/Carrier.png";
import appConfig from "./config";
import { useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import MessageIcon from '@mui/icons-material/Message';
import DeleteIcon from '@mui/icons-material/Delete';

import { TextField, InputAdornment } from "@material-ui/core";
import SearchIcon from '@mui/icons-material/Search';
import { ListItemButton } from "@mui/material";


const RequirementsForGenAI = ({ fetchAPI }) => {
  const [numberOfRows, setNumberOfRows] = useState('');
  const classes = useStyles();
  const username = getUsernameFromToken();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openHelpDrawer, setOpenHelpDrawer] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const open = Boolean(anchorEl);
  const [messagePairs, setMessagePairs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chatDrawerStatus, setchatDrawerStatus] = useState(false);
  const handleSearch = (event) => {
    event.stopPropagation();
    setSearchTerm(event.target.value);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("user");
    logout(appConfig.api);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleHelpClick = () => {
    setOpenHelpDrawer(prevState => !prevState);
  };

  const handleCloseHelpDrawer = () => {
    setOpenHelpDrawer(false);
  };


  const [rules, setRules] = useState({});

  const [chatID, setChatID] = useState([]);
  const [activeChatID, setActiveChatId] = useState(null);
  const [chatStarted, setChatStarted] = useState(false);
  const [deleteDialogStatus, setDeleteDialogStatus] = useState(false);
  const [chattoDelete, setchattoDelete] = useState(null);

  const handleDeleteChat = (id) => {
    setchattoDelete(id);
    setDeleteDialogStatus(true);
  }

  const fetchChatNames = async () => {
    const payload = { "username": username, "requestId": "chat_names" };
    const response = await fetchAPI.post('/get_chat_names', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
      },
    });
    const chatNames = response.data.body;
    if (Array.isArray(chatNames)) {
      chatNames.reverse();
      setChatID(prevChatIDs => [...chatNames, ...prevChatIDs])
    }
    return chatNames;
  };


  const handleConfirmDelete = async () => {
    setLoading(true)
    setDeleteDialogStatus(false);

    try {
      const payload = { "username": username, "requestId": chattoDelete };
      const response = await fetchAPI.post('/delete_chat', payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        },
      })
      if (response.status === 200) {
        setChatID(prevChatIDs => prevChatIDs.filter(chatId => chatId !== chattoDelete));
        if (activeChatID === chattoDelete) {
          setActiveChatId(null);
          setMessagePairs([]);
          setChatStarted(false)
        }
        setLoading(false);
        alert("Chat has been deleted successfully");
      }
    }
    catch (err) {
      console.log("error in deleting the chat ", err)
      setLoading(false);
      alert(err)
    }
  };

  const handleCancelDelete = () => {
    setDeleteDialogStatus(false);
    setchattoDelete(null);
  }

  useEffect(() => {
    const token = localStorage.getItem("msal.idtoken");
    if (!token) {
      console.log("No authentication token found");
      return;
    }

    fetchAPI('/rules', {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      },
    })
      .then(response => {
        if (response.status != 200) {
          throw new Error(`HTTP Error! Status: ${response.status}`);
        }
        return response.data;
      })
      .then(data => {
        setRules(data);
      })
      .catch(err => {
        console.log("This is error in rules:", err);
      });

    const chatNames = fetchChatNames();


  }, []);

  const beautify = (category) => {

    const capitalized =
      category.charAt(0).toUpperCase()
      + category.slice(1)
    return capitalized;
  }
  const [newChatDialogOpen, setNewChatDialogOpen] = useState(false);
  const [newChatName, setNewChatName] = useState('');
  const [newChatNameError, setNewChatNameError] = useState(false);
  const [newChatNameErrorMessage, setNewChatNameErrorMessage] = useState('');
  const [newChatResolve, setNewChatResolve] = useState(null);

  const handleNewChatButton = () => {
    return new Promise((resolve, reject) => {
      setNewChatName('');
      setNewChatNameError(false);
      setNewChatNameErrorMessage('');
      setNewChatDialogOpen(true);
      setNewChatResolve(() => resolve);
    });
  };

  const handleNewChatDialogClose = () => {
    setNewChatDialogOpen(false);

    if (newChatResolve) {
      newChatResolve(null);
      setNewChatResolve(null);
    }
  };

  const handleNewChatNameChange = (event) => {
    setNewChatName(event.target.value);
    if (event.target.value.trim()) {
      setNewChatNameError(false);
      setNewChatNameErrorMessage('');
    }
  };

  const handleCreateNewChat = () => {
    if (!newChatName.trim()) {
      setNewChatNameError(true);
      return;
    }

    if (chatID.includes(newChatName.trim())) {
      setNewChatNameError(true);
      setNewChatNameErrorMessage("Chat name already exists");
      return;
    }

    const newchatID = newChatName.trim();
    setChatID(prevChatIDs => [newchatID, ...prevChatIDs]);
    setActiveChatId(newchatID);
    setMessagePairs([]);
    setNewChatDialogOpen(false);

    if (newChatResolve) {
      newChatResolve(newchatID);
      setNewChatResolve(null);
    }
  };
  const unpackmessages = (response) => {
    console.log("unpacking messages");

    if (!response || !Array.isArray(response)) {
      console.error("Invalid response format:", response);
      return;
    }

    response.forEach((item) => {
      if (item.req_type === "single") {
        // Handle single requirement
        if (item.requirement && item.requirement.data) {
          const queryData = item.requirement.data;
          const messageId = item.req_id;

          if (queryData.question && queryData.aiResponse) {
            const req_type = item.req_type
            const aiResponse = {
              body: queryData.aiResponse,
              gotResponse: true,
              question: queryData.question,
            };

            setMessagePairs((prevPairs) => [
              { messageId, req_type, aiResponse },
              ...prevPairs
            ]);
          }
        }
      } else if (item.req_type === "multiple") {
        // Handle multiple requirements
        if (item.requirements && Array.isArray(item.requirements)) {
          const messageId = item.req_id
          const req_type = item.req_type
          const aiResponse = {
            body: item.requirements,
            gotResponse: true
          }
          setMessagePairs((prevPairs) => [
            { messageId, req_type, aiResponse },
            ...prevPairs
          ]);

        }
      }
    });

    setChatStarted(true);
  };

  const handleChatClick = async (id) => {
    setLoading(true);
    setMessagePairs([]);
    setActiveChatId(id);
    try {
      const payload = { "username": username, "requestId": id };
      const response = await fetchAPI.post('/get_chatHistory', payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        },
      });
      const messages = response.data.body;
      if (Array.isArray(messages)) {
        unpackmessages(messages);
      }
      setLoading(false);
    }
    catch(err){
      console.log("this is error ",err)
      alert(err);
      setLoading(false);
    }
  }

  return (
    <SystemContext.Provider value={{ numberOfRows, setNumberOfRows }}>
      <CssBaseline />
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <AppBar position="static" className={classes.appbar} style={{ marginBottom: 0, position: "fixed" }}>
          <Toolbar variant="dense" style={{ padding: 0 }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Open drawer"
              style={{ paddingLeft: "25px", marginLeft: "35px", width: "100px" }}
            >
              <Avatar aria-label="Logo" src={logo} className={classes.avatar} />
            </IconButton>
            <Typography className={classes.title} variant="h6" noWrap>
              <label style={{ display: "flex", justifyContent: "center", fontSize: "1.5rem", fontFamily: "Roboto, sans-serif" }}>
                AI/ML CoE - AI for Requirements Engineering
              </label>
            </Typography>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Help">
                <IconButton
                  onClick={handleHelpClick}
                  size="small"
                  sx={{ ml: 2 }}
                  aria-label="Help"
                >
                  <HelpOutline sx={{ color: "#fff", fontSize: 32 }} />
                </IconButton>
              </Tooltip>
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title={username}>
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ ml: 2 }}
                  aria-controls={open ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <Avatar sx={{ width: 32, height: 32 }} style={{ backgroundColor: "silver" }}>
                    {username
                      ? username.split(" ").map((word) => word.charAt(0).toUpperCase()).join("")
                      : "UK"}
                  </Avatar>
                </IconButton>
              </Tooltip>
            </Box>
            {/* Help Icon */}
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <div style={{ display: 'inline-grid', padding: '5px' }}>
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </div>
            </Menu>
          </Toolbar>
        </AppBar>
        <Box sx={{
          flexGrow: 1,
          overflow: 'hidden',
          marginTop: '64px',
          marginLeft: chatDrawerStatus ? '175px' : '64px',
          marginRight: openHelpDrawer ? '350px' : '0',
        }}>
          <Router>
            <ChatBox fetchAPI={fetchAPI} username={username} openHelpDrawer={openHelpDrawer} handleNewChatButton={handleNewChatButton} chatStarted={chatStarted} setChatStarted={setChatStarted} messagePairs={messagePairs} setMessagePairs={setMessagePairs} activeChatID={activeChatID} loading={loading} setLoading={setLoading} path="/" />
          </Router>
          {/* Other content */}
        </Box>
      </Box>
      <Drawer

        variant="persistent"
        anchor="right"
        open={openHelpDrawer}
        onClose={handleClose}
        aria-labelledby="help-drawer-title"
        PaperProps={{
          style: {
            top: '64px',
            height: 'calc(100% - 64px)',
            width: openHelpDrawer ? '100%' : '0%',
            maxWidth: '380px',
            overflowX: 'hidden'
          },
        }}
        BackdropProps={{ style: { top: '64px' } }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: "#efefef",

          }}
          role="presentation"
        >
          <Box sx={{
            top: 0,
            position: 'sticky',
            zIndex: 1,
            backgroundImage: 'linear-gradient(to right, rgba(240, 243, 248, 0.87) 0%,rgba(223,233,250,0.87) 100%)',
            padding: 2,
            paddingBottom: 4,
            paddingTop: 6,

          }}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              marginBottom: 1
            }}>
              <Typography variant="h6" style={{ color: '#152C73' }}><strong>INCOSE Rules</strong></Typography>
              <IconButton
                onClick={handleCloseHelpDrawer}
                aria-label="close drawer"
                style={{ position: 'absolute', right: -10, top: -8 }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box sx={{ height: '10px' }}>
            </Box>

            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search rules..."
              value={searchTerm}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                style: { backgroundColor: 'white', width: "95%", margin: 'auto' }
              }}
              size="small"
              sx={{
                mb: 3,
              }}
            />
            <Box sx={{ height: '20px', maxWidth: '100%' }} />
          </Box>
          <Box sx={{
            flexGrow: 1,
            overflowY: 'auto',
            overflowX: 'hidden', // Add this to hide horizontal scrollbar
            padding: 2,
            marginLeft: 2,
            width: 'calc(100% - 16px)'
          }}>
            {Object.entries(rules).map(([category, ruleSet]) => {
              const filteredRules = ruleSet.filter(rule =>
                category.toLowerCase().includes(searchTerm.toLowerCase()) ||
                rule.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                rule.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                rule.rule.toLowerCase().includes(searchTerm.toLowerCase())
              )

              if (filteredRules.length === 0) return null
              return (
                <Box key={category} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: '4px' }}>
                  <Typography variant="subtitle1" sx={{ alignSelf: 'flex-start' }}><strong>{beautify(category)}</strong></Typography>
                  {filteredRules.map((rule, index) => (
                    <Box key={index} mb={2} sx={{ textAlign: 'left', paddingLeft: '16px' }}>
                      <Typography variant="subtitle2" >
                        <strong>{rule.rule}: </strong>
                        <em>{rule.title}</em>
                      </Typography>
                      <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>{rule.description}</Typography>
                    </Box>
                  ))}
                </Box>
              )
            })}
          </Box>
        </Box>
      </Drawer>
      <Drawer
        variant="permanent"
        anchor="left"
        aria-labelledby="chat-selection"

        PaperProps={{
          style: {
            top: '64px',
            height: 'calc(100% - 64px)',
            width: chatDrawerStatus ? '100%' : "64px",
            maxWidth: '175px',
            flexShrink: 0,
            overflow: 'hidden',
          },
          onMouseEnter: () => setchatDrawerStatus(true),
          onMouseLeave: () => setchatDrawerStatus(false)
        }}
        BackdropProps={{ style: { top: '64px' } }}
      >
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          height: '100%',
          paddingTop: '10px'
        }}>
          <Button
            size="small"
            variant="outlined"
            style={{
              width: chatDrawerStatus ? '80%' : "32px",
              height: '32px',
              minWidth: chatDrawerStatus ? 'auto' : '32px',
              margin: '0 auto',
              position: 'relative',
              overflow: 'hidden',
              padding: chatDrawerStatus ? '6px 16px' : '6px 0',
              justifyContent: 'center'
            }}
            onClick={handleNewChatButton}
            disabled={loading && chatStarted == false}
          >
            <span style={{
              opacity: chatDrawerStatus ? 1 : 0,
              position: 'absolute',
              whiteSpace: 'nowrap',
              left: '8px',
            }}>
              New Chat
            </span>
            <AddIcon style={{
              position: 'absolute',
              right: chatDrawerStatus ? '8px' : '50%',
              transform: chatDrawerStatus ? 'rotate(-90deg)' : 'translateX(50%) rotate(90deg)',

            }} />
          </Button>
          <List sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {chatID.map((id) => (
              <ListItem key={id} sx={{ width: '90%', justifyContent: 'space-between', alignItems: 'center' }}>
                <ListItemButton
                  disabled={loading && activeChatID != id}
                  onClick={() => handleChatClick(id)}
                  selected={activeChatID === id}
                  sx={{
                    color: "#a3aed0 !important",
                    flex: 1,
                    width: chatDrawerStatus ? '142px' : '32px',
                    height: '32px',
                    padding: 0,
                    display: 'flex',
                    justifyContent: chatDrawerStatus ? 'flex-start' : 'center',
                    alignItems: 'center',

                    '&.Mui-selected': {
                      backgroundColor: "rgba(223,233,250,0.87)",
                      color: '#152C73 !important',
                      borderRadius: '5px'
                    },
                    '&:hover': {
                      backgroundColor: '#f0f0f0',
                      color: '#a3aed0',
                      borderRadius: '5px'
                    },
                  }}
                >
                  <MessageIcon sx={{ fontSize: 15, color: activeChatID === id ? '#152C73' : '#a3aed0', marginLeft: chatDrawerStatus ? 1 : 1.5, marginRight: 1 }} />
                  <Typography
                    sx={{
                      fontWeight: "900",
                      fontSize: "large",
                      flexGrow: 1,
                      textAlign: 'center',
                      padding: '0 5px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: 'inherit',  // This will inherit the color from parent ListItemButton
                    }}
                  >
                    {chatDrawerStatus ? id.substring(0, 10) : null}
                  </Typography>
                  <Box sx={{ marginLeft: 'auto' }}>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteChat(id);
                      }}
                      sx={{ padding: 0 }}
                    >
                      {chatDrawerStatus ? <DeleteIcon sx={{ fontSize: 17, color: activeChatID === id ? '#152C73' : '#a3aed0' }} /> : null}
                    </IconButton>
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <Dialog
        open={deleteDialogStatus}
        onClose={handleCancelDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this chat?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={newChatDialogOpen}
        onClose={handleNewChatDialogClose}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Please enter chat name</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Chat Name"
            type="text"
            fullWidth
            value={newChatName}
            onChange={handleNewChatNameChange}
            error={newChatNameError}
            helperText={newChatNameError ? (newChatNameErrorMessage || "Chat name cannot be empty") : ""}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleCreateNewChat();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNewChatDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCreateNewChat} color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
      {loading && (
        <div className="overlay">
          <div className="loader"></div>
        </div>
      )}
    </SystemContext.Provider>
  );
};
export default RequirementsForGenAI;
